module.exports = __webpack_public_path__ + "media/images/icons/icon-buy-stats-0041d5c4ead300aececa1bffed2afcc7.svg";